import { useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { FORM_PAGES } from '../../../components/Form/types';
import FormInfoBookingHandling from '../../../components/FormInfo/BookingHandling/FormInfo';
import { CompletePaymentButton, WarningImageContainer } from '../../../components/FormInfo/BookingHandling/styled';
import { FORM_INFO_TYPES } from '../../../components/FormInfo/types';
import LoadingSpinner from '../../../components/Shared/LoadingSpinner/LoadingSpinner';
import WarningImage from '../../../images/warning.svg';
import { setFormPage } from '../../../reactive/actions';
import Colors from '../../../utils/Colors';
import { useCheckOrdersForPaymentActions } from '../../../utils/handleOrderPaymentAction';
import { GetAllUserAppointments } from '../../../utils/queries';

const BookingHandling = () => {
  const { data, startPolling, stopPolling } = useQuery(GetAllUserAppointments, {
    fetchPolicy: 'cache-and-network'
  });
  const [loading, setLoading] = useState<boolean>(false);

  const [handleActions, { loading: useCheckOrdersForPaymentActionsLoading }] = useCheckOrdersForPaymentActions(10000);

  useEffect(() => {
    startPolling(10000);

    return () => {
      stopPolling();
    };
  }, [data]);

  const handleClick = async () => {
    setLoading(true);
    await handleActions();
    setLoading(false);

    setFormPage(FORM_PAGES.PRODUCTS);
  };

  return (
    <FormInfoBookingHandling
      type={FORM_INFO_TYPES.BOOKING_HANDLING}
      loading={useCheckOrdersForPaymentActionsLoading}
      handleClick={handleClick}
      aboveTitleElement={
        <WarningImageContainer>
          <WarningImage />
        </WarningImageContainer>
      }
      children={
        <CompletePaymentButton type="button" onClick={handleClick}>
          {loading ? <LoadingSpinner color={Colors.primaryGray} /> : <span>Complete Payment</span>}
        </CompletePaymentButton>
      }
    />
  );
};

export default BookingHandling;
